import { Type } from "nanium/objects";

export class GeoLocationType {
  @Type(String) latitude: string;
  @Type(String) longitude: string;
}
